import TicketListItem from './container';

export default TicketListItem;



// WEBPACK FOOTER //
// ./app/src/components/EventTicketsPage/components/TicketListItem/index.js